import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../contexts/LanguageContext';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  noIndex?: boolean;
}
export function SEO({
  title = 'CyberSecurityProtocol | Practical Cybersecurity Protocols for Individuals & Organizations',
  description = 'Practical, standards-aligned cybersecurity protocols, risk assessments, and actionable guidance to help individuals and organizations reduce cyber risk and improve digital security readiness.',
  keywords = 'cybersecurity protocol, security risk assessment, personal security, organizational security, cyber risk, security guidance, standards-aligned security',
  image = '/og-image.png',
  url = 'https://cybersecurityprotocol.org',
  type = 'website',
  noIndex = false
}: SEOProps) {
  const {
    language
  } = useLanguage();
  const localeMap: Record<string, string> = {
    en: 'en_US',
    id: 'id_ID',
    ar: 'ar_AR',
    zh: 'zh_CN',
    fr: 'fr_FR',
    ru: 'ru_RU',
    es: 'es_ES'
  };
  const currentLocale = localeMap[language] || 'en_US';
  const baseUrl = 'https://cybersecurityprotocol.org';
  return <Helmet data-id="element-600">
      <title data-id="element-601">{title}</title>
      <meta name="title" content={title} data-id="element-602" />
      <meta name="description" content={description} data-id="element-603" />
      <meta name="keywords" content={keywords} data-id="element-604" />
      <meta name="author" content="UXER / Asosiasi Teknologi Informasi dan Open Source (ATIOS)" data-id="element-605" />
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow'} data-id="element-606" />
      <meta name="language" content={language} data-id="element-607" />

      <meta property="og:type" content={type} data-id="element-608" />
      <meta property="og:url" content={url} data-id="element-609" />
      <meta property="og:title" content={title} data-id="element-610" />
      <meta property="og:description" content={description} data-id="element-611" />
      <meta property="og:image" content={image} data-id="element-612" />
      <meta property="og:site_name" content="CyberSecurityProtocol" data-id="element-613" />
      <meta property="og:locale" content={currentLocale} data-id="element-614" />

      <meta property="twitter:card" content="summary_large_image" data-id="element-615" />
      <meta property="twitter:url" content={url} data-id="element-616" />
      <meta property="twitter:title" content={title} data-id="element-617" />
      <meta property="twitter:description" content={description} data-id="element-618" />
      <meta property="twitter:image" content={image} data-id="element-619" />

      <link rel="alternate" hrefLang="en" href={`${baseUrl}/en`} data-id="element-620" />
      <link rel="alternate" hrefLang="id" href={`${baseUrl}/id`} data-id="element-621" />
      <link rel="alternate" hrefLang="ar" href={`${baseUrl}/ar`} data-id="element-622" />
      <link rel="alternate" hrefLang="zh" href={`${baseUrl}/zh`} data-id="element-623" />
      <link rel="alternate" hrefLang="fr" href={`${baseUrl}/fr`} data-id="element-624" />
      <link rel="alternate" hrefLang="ru" href={`${baseUrl}/ru`} data-id="element-625" />
      <link rel="alternate" hrefLang="es" href={`${baseUrl}/es`} data-id="element-626" />
      <link rel="alternate" hrefLang="x-default" href={`${baseUrl}/en`} data-id="element-627" />

      <meta name="theme-color" content="#06b6d4" data-id="element-628" />
      <meta name="msapplication-TileColor" content="#06b6d4" data-id="element-629" />

      <link rel="canonical" href={url} data-id="element-630" />

      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-631" />
    </Helmet>;
}